import { apiFetch } from "@/lib/api";

export type InventoryHistoryGranularity = "day" | "week" | "month";
export type InventoryHistoryGroupBy =
  | "sku"
  | "description"
  | "category"
  | "location";
export type InventoryHistoryMetric = "quantity" | "value";

export interface InventoryHistoryPoint {
  period: string;
  quantity: number;
  value: number;
  estimated: boolean;
}

export interface InventoryHistorySeries {
  key: string;
  label: string;
  points: InventoryHistoryPoint[];
}

export interface InventoryHistoryFilterOption {
  id: number;
  name: string;
}

export interface InventoryHistoryResponse {
  from: string;
  to: string;
  granularity: InventoryHistoryGranularity;
  groupBy: InventoryHistoryGroupBy;
  periods: string[];
  series: InventoryHistorySeries[];
  backfillThrough: string | null;
  locations: InventoryHistoryFilterOption[];
  categories: InventoryHistoryFilterOption[];
}

export interface InventoryHistoryQuery {
  from: string;
  to: string;
  granularity: InventoryHistoryGranularity;
  groupBy: InventoryHistoryGroupBy;
  locationIds?: number[];
  categoryIds?: number[];
}

export async function fetchInventoryHistory(
  query: InventoryHistoryQuery,
): Promise<InventoryHistoryResponse> {
  const parameters = new URLSearchParams({
    from: query.from,
    to: query.to,
    granularity: query.granularity,
    group_by: query.groupBy,
  });
  if (query.locationIds && query.locationIds.length > 0) {
    parameters.set("location_ids", query.locationIds.join(","));
  }
  if (query.categoryIds && query.categoryIds.length > 0) {
    parameters.set("category_ids", query.categoryIds.join(","));
  }
  return apiFetch<InventoryHistoryResponse>(
    `/api/accounting/inventory-history?${parameters.toString()}`,
  );
}
